/**
 * Which vaults the tenants directory lists. Carried in the `/tenants` URL as `?vaults=complimentary` so
 * the summary's complimentary count can link straight to the list behind it (and the link can be shared).
 * Anything else — absent, misspelt, stale — is the unfiltered directory.
 */
export type VaultListFilterView = 'all' | 'complimentary';

export function parseVaultListFilter(search: Record<string, unknown>): VaultListFilterView {
    return search['vaults'] === 'complimentary' ? 'complimentary' : 'all';
}

export function vaultListHref(filter: VaultListFilterView): string {
    return filter === 'complimentary' ? '/tenants?vaults=complimentary' : '/tenants';
}
